import { render, staticRenderFns } from "./article.vue?vue&type=template&id=39278f2a&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=39278f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39278f2a",
  null
  
)

export default component.exports